import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldCards from '~/components/zod/ZodFieldCards';
import { McmSlideshowOrientation } from '~/tenants/mcm/performable/slideshow/McmSlideshowConfig';

export default function McmSlideshowForm(): ReactElement {
  return (
    <>
      <FormHorizontal name="orientation" label="Orientation">
        <ZodFieldCards
          required
          name="orientation"
          options={[
            { value: McmSlideshowOrientation.HORIZONTAL, title: 'Horizontal', cost: '69.95' },
            { value: McmSlideshowOrientation.VERTICAL, title: 'Vertical', cost: '69.95' },
            { value: McmSlideshowOrientation.BOTH, title: 'Both', cost: '119.95' },
          ]}
        />
      </FormHorizontal>
    </>
  );
}
